import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {Router, ActivatedRoute} from '@angular/router';
import {TitleService} from '@app/services/title.service';
import {DomSanitizer} from '@angular/platform-browser';
import * as routes from '@app/routes';
import {select, Store} from '@ngrx/store';
import {Actions, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {
  getProjectError,
  getProjectSuccess,
  getLoggedInUser,
  IAuthenticationState,
  IProjectState,
  ProjectList,
  IClientState,
  getClientError,
  getClients,
  ProjectDelete,
  ResetProjectState,
  ProjectCopy,
  ProjectCreateSuccess,
  ProjectUpdateSuccess,
  getPaginatedProjects,
  ClientsListAll, getProjects, ClientsList, getPaginatedClients,
  IOrganizationState,
  OrganizationsListAll,
  getOrganizationsListAll,
} from '@app/stores';
import {takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '@app/services/project.service';
import {Client, Organization, Project} from '@app/modules/shared/models';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';
import {ProjectCopyComponent} from '@app/modules/project/project-copy/project-copy.component';
import moment from 'moment-timezone';
import {DataTableDirective} from 'angular-datatables';
import {Constants} from '@app/consts';
import {LoaderService} from '@app/services/loader.service';
import * as DataTables from 'datatables.net';

import {ListUrlStateService} from '@app/services/list-url-state.service';
import type {DataProtectionAnonymizeScope, DeletionPreview} from '@app/services/data-protection.service';
import {ANONYMIZE_SUMMARY, canonicalScope, evidenceSizeWarning} from '@app/modules/data-protection/data-protection-vocabulary';
@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css'],
  providers: [Constants]
})
export class ProjectListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('deleteProjectTpl') deleteProjectTpl: TemplateRef<any>;
  // What the delete confirmation shows; set just before it opens. `type` is two-way bound
  // to the dialog's radio choice, so it is read back at confirm time.
  deleteConfirm: {
    approvers: Array<{name: string; email: string}>;
    creatorName: string | null;
    warning: string | null;
    isAnonymized: boolean;
    // False where this environment sends no data-protection mail at all. The dialog must
    // then not promise an approval email, because none is coming - the request is reviewed
    // on the Data Protection dashboard instead.
    emailsEnabled: boolean;
    // True while the project's activity end date is still ahead (or unset). The server
    // refuses either request type for such a project, so the dialog explains and offers
    // no choice rather than offering one that would be rejected on submit.
    isActive: boolean;
    endsAt: string | null;
    type: 'anonymize' | 'delete';
    scope: DataProtectionAnonymizeScope[];
    evidenceWarnings: { [type: string]: string | null };
  } | null = null;

  @ViewChild(DataTableDirective, {static: true})
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Config = {};
  dtOptions: any = {};
  loader$: Observable<boolean>;
  dtTrigger: Subject<any> = new Subject();
  routes = routes;
  currentUser: any;
  currentUserSubscription: Subscription;
  selectedClient = 'All';
  projectPlaceholder = 'All Projects';
  // selectedStatus = 'Active';
  // selectedStatusSlug = 'active';
  public projects: Project[] = [];
  projectdata: object;
  role: string;
  showAll = false;
  // showAllCompleted = false;
  // showDraftProject = false;
  planners: Client[] = [];
  title = 'Project List';
  imageDefault = '../../assets/images/project-default.png';
  searchPhrase: string;
  unsubscriber = new Subject();
  deleteAction = false;
  // How many account managers the approval email went to, so the confirmation toast
  // can say whether anyone was actually asked.
  pendingDeleteApprovers = 0;
  anonymizeSummary = ANONYMIZE_SUMMARY;
  private pendingDeleteType: 'anonymize' | 'delete' = 'anonymize';
  copyAction = false;
  totalInfluencers = 0;
  totalPageViews = 0;
  totalReferrals = 0;
  totalShares = 0;
  ajaxCallback: any;
  private datatableInstance: DataTables.Api<any>;
  private searchDelay;
  viewType = 'card';
  projectSearchValue = '';
  clientSearchValue = '';
  projectsList = [];
  allProjectList = [];
  clientPlaceholder = 'Search by Clients';
  // statusPlaceholder = 'Active';
  pageLength = 100;
  selectedProject: number = null;
  projectListFilter = {};
  isOnLoad = true;
  pageNumber = 0;
  perPage = 100;
  selectedStatus: any = 'all';
  clientPageNumber = 0;
  totalClients = 0;
  errorMessage = '';
  organizations: Organization[] = [];
  selectedOrganization: any = 'All';

  constructor(
    private listUrlState: ListUrlStateService,
    private route: ActivatedRoute,
    private authenticationStore: Store<IAuthenticationState>,
    private projectStore: Store<IProjectState>,
    private clientStore: Store<IClientState>,
    private router: Router,
    public constants: Constants,
    private toastrService: ToastrService,
    private titleService: TitleService,
    public domSanitizer: DomSanitizer,
    private _modalService: NgbModal,
    private sbModal: SbModalService,
    private readonly cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private organizationStore: Store<IOrganizationState>,
    private projectService: ProjectService,
    private actions$: Actions,
  ) {
    this.projectStore.dispatch(ResetProjectState({params: {error: '', paginatedProjects: null}}));
      this.route.queryParams.subscribe(async (queryParams) => {
        if (queryParams.clientId) {
          this.selectedClient = queryParams.clientId;
        } else {
          this.selectedClient = 'All';
        }
      });
    this.subscribeStores();
    this.titleService.set(this.title);
  }

  subscribeStores() {
    // Modal forms leave the list mounted, so reload after their save succeeds.
    this.actions$.pipe(
      ofType(ProjectCreateSuccess, ProjectUpdateSuccess),
      takeUntil(this.unsubscriber)
    ).subscribe(action => {
      const created = action.type === ProjectCreateSuccess.type;
      // Recompute the empty state too when creating the first project.
      this.isOnLoad = true;
      if (this.datatableInstance) {
        this.datatableInstance.ajax.reload(null, created);
      } else {
        if (created) {
          this.pageNumber = 0;
        }
        this.loadAllProjects(this.projectSearchValue);
      }
    });

    this.authenticationStore.pipe(select(getLoggedInUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(user => {
          this.currentUser = user;
          // Redirect user if they are influencer
          if (this.currentUser && this.currentUser.user_type === '2') {
            const firstProjectId = this.currentUser.user.influencers[0].segment.project_id;
            this.router.navigate([
              'projects',
              firstProjectId,
              'share'
            ]);
          }
        }
      );

    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.errorMessage = 'Unable to load the page please try again';
          this.toastrService.error(error);
        }
      });

    this.clientStore.pipe(select(getClientError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastrService.error(error);
        }
      });

    this.projectStore.pipe(select(getProjectSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        if (success) {
          if (this.deleteAction) {
            this.deleteAction = false;
            const notified = this.pendingDeleteApprovers;
            this.pendingDeleteApprovers = 0;
            const requested = `${this.pendingDeleteType === 'anonymize' ? 'Anonymization' : 'Deletion'} requested.`;
            this.toastrService.success(notified
              ? `${requested} An approval email was sent to ${notified} account `
                + `manager${notified === 1 ? '' : 's'}.`
              : `${requested} It can be approved on the Data Protection dashboard.`);
            this.loadAllProjects();
          }

          if (this.copyAction) {
            this.copyAction = false;
            this.loadAllProjects();
          }
        }
      });

    this.projectStore.pipe(select(getPaginatedProjects))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((paginatedProjects: any) => {
          if (paginatedProjects) {
            this.errorMessage = '';
            let projectsNew = false;
            if (this.projects) { projectsNew = true; }
            this.projects = paginatedProjects.list;
            if ((this.isOnLoad) && (!localStorage.getItem('projectFilterList') || projectsNew)) {
              this.allProjectList = this.projects;
              this.isOnLoad = false;
            }
            if (this.ajaxCallback) {
              this.ajaxCallback({
                recordsTotal: paginatedProjects.paging.total,
                recordsFiltered: paginatedProjects.paging.total,
                data: []
              });
              setTimeout(() => {
                (this.datatableInstance as any).columns.adjust();
              }, 500);
            }
            this.filterTotal(this.projects);
          }
        }
      );

    // this.projectStore.pipe(select(getProjects))
    //   .pipe(takeUntil(this.unsubscriber))
    //   .subscribe(projects => {
    //     if (projects) {
    //       this.allProjectList = projects;
    //     }
    //   });

    this.clientStore.pipe(select(getPaginatedClients))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(paginatedClients => {
        if (paginatedClients) {
          this.totalClients = paginatedClients.paging.total;
          this.clientPageNumber = parseInt(paginatedClients.paging.page);
          this.planners = [...this.planners, ...paginatedClients.list];
        }
      });

    this.organizationStore.pipe(select(getOrganizationsListAll))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(data => {
        if (data) {
          this.organizations = data;
        }
      });
  }

  filterTotal(projects) {
    this.totalInfluencers = 0;
    this.totalPageViews = 0;
    this.totalReferrals = 0;
    this.totalShares = 0;

    projects.forEach(item => {
      this.totalInfluencers += item.influencers_count ? Number(this.getTotalInfluencersCount(item.influencers_count)) : 0;
      this.totalReferrals += item.referrals_count ? Number(item.referrals_count) : 0;
      this.totalPageViews += item.pageviews_count ? Number(item.pageviews_count) : 0;

      let sharesTotal = 0;
      sharesTotal = item.social_share_count ? Number(item.social_share_count) : 0;
      sharesTotal += item.registration_click_count ? Number(item.registration_click_count) : 0;

      this.totalShares += sharesTotal;
    });
  }

  getSharesTotal(project) {
    let sharesTotal = 0;
    sharesTotal = project.social_share_count ? Number(project.social_share_count) : 0;
    sharesTotal += project.registration_click_count ? Number(project.registration_click_count) : 0;

    return sharesTotal;
  }

  ngOnInit() {
    this.loader$ = this.loaderService.loader$;
    if (localStorage.getItem('projectFilterList') && JSON.parse(localStorage.getItem('projectFilterList')).projectViewType) {
      this.viewType = JSON.parse(localStorage.getItem('projectFilterList')).projectViewType;
    }
    this.route.queryParams.subscribe(params => {
      const searchParam = params['search'] || '';
      if (searchParam !== this.projectSearchValue) {
        this.projectSearchValue = searchParam;
        if (this.datatableInstance) {
          const currentSearchValue = (this.datatableInstance as any).search();
          if (currentSearchValue !== searchParam) {
            const searchBox = $('div.dataTables_filter input');
            if (searchBox.length) {
              searchBox.val(searchParam);
            }
            (this.datatableInstance as any).search(searchParam).draw();
          }
        }
      }
    });
    // if (localStorage.getItem('projectFilterList') && JSON.parse(localStorage.getItem('projectFilterList')).selectedClient) {
    //   this.selectedClient = JSON.parse(localStorage.getItem('projectFilterList')).selectedClient;
    // }
    // if (localStorage.getItem('projectFilterList') && JSON.parse(localStorage.getItem('projectFilterList')).selectedClientName) {
    //   this.clientPlaceholder = JSON.parse(localStorage.getItem('projectFilterList')).selectedClientName;
    // }
    // Filters from a bookmarked or shared address; the table writes them back after each draw.
    const urlFilters = this.listUrlState.read(['organization', 'status', 'stats']).filters;
    this.selectedOrganization = urlFilters.organization || this.selectedOrganization;
    this.selectedStatus = urlFilters.status || this.selectedStatus;
    this.showAll = this.showAll || urlFilters.stats === '1';
    this.datatableSettings();
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api<any>) => {
        dtInstance.destroy();
        this.dtTrigger.next(undefined);
      });
    } else {
      this.dtTrigger.next(undefined);
    }
    this.manageRole();
    if (this.currentUser?.can( 'load-all-planners', 'project-ui')) {
      this.loadAllPlanners();
    }
    if (this.currentUser?.can('filter-by-organization', 'project-ui')) {
      this.loadAllOrganizations();
    }
  }

  ngAfterViewInit() {
    this.dtTrigger.next(undefined);
  }

  datatableSettings() {
    const columns = ['image', 'title', 'campaign_count', 'influencers_count', 'click_rate', 'pageviews_count', 'created_at'];
    // @ts-ignore
    this.dtOptions = this.listUrlState.bind({
      scrollCollapse: true,
      pagingType: 'full_numbers',
      responsive: false,
      ordering: true,
      columnDefs: [{orderable: false, targets: 'no-sort'}],
      processing: true,
      lengthMenu: [10, 50, 100, 500],
      pageLength: this.pageLength,
      paging: true,
      serverSide: true,
      scrollX: true,
      searching: true,
      dom: '<"top"fil>rt<"bottom"p><"clear">',
      // scrollY: "100vh",
      fixedHeader: {
        header: true,
        footer: true,
        headerOffset: 55 ,
      },
      language: {
        search: '',
        searchPlaceholder: 'Search Projects'
      },
      drawCallback: function (setting) {
        const totalPages = this.api().page.info().pages;
        if (totalPages <= 1) {
          document.querySelector('.dataTables_paginate').classList.add('d-none');
        } else {
          document.querySelector('.dataTables_paginate').classList.remove('d-none');
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api<any>) => {
          this.datatableInstance = dtInstance;
          this.ajaxCallback = callback;

          this.pageLength = dataTablesParameters.length;
          this.pageNumber = (dataTablesParameters.start / this.pageLength);
          this.datatableInstance.page.len(this.pageLength);

          const searchBox = $('div.dataTables_filter input');
          searchBox.off('keyup.DT input.DT search.DT keyup.sbSearch');

          const searchParam = this.projectSearchValue || '';
          if (searchParam) {
            // Restores the term after a redraw, but never into the box being typed in: the
            // committed term can be a keystroke behind it, and writing it back erased that letter.
            if (!searchBox.is(document.activeElement)) {
              searchBox.val(searchParam);
            }
            dataTablesParameters.search.value = searchParam;
          }

          // Handle typing
          searchBox.on('keyup.sbSearch', () => {
            const search: any = searchBox.val();
            clearTimeout(this.searchDelay);
            this.searchDelay = setTimeout(() => {
              if (search !== this.projectSearchValue) {
                this.projectSearchValue = search;
                (this.datatableInstance as any).search(search).draw();
              }
            }, 300);
          });

          // Handle "x" clear (native input event)
          searchBox.on('search.DT', () => {
            if (this.projectSearchValue) {
              this.projectSearchValue = '';
              (this.datatableInstance as any).search('').draw();
            }
          });

          const orderBy = {
            ...dataTablesParameters.order[0],
            column: dataTablesParameters.order[0].column === 1 ? 'title' :'created_at'
          };
          // this.projectSearchValue = dataTablesParameters.search.value;
          this.loadAllProjects(this.projectSearchValue, orderBy);
        });
      },
      columns: [
        {data: null}, {data: null}, {data: null}, {data: null},
        {data: null}, {data: null}, {data: null}, {data: null},
        {data: null}
      ],
      order : [6, 'desc']
    }, {
      // clientId keeps the name the dashboard's links already use.
      filters: () => ({
        clientId: this.selectedClient !== 'All' ? this.selectedClient : null,
        organization: this.selectedOrganization !== 'All' ? this.selectedOrganization : null,
        status: this.selectedStatus !== 'all' ? this.selectedStatus : null,
        stats: this.showAll ? '1' : null,
      }),
    });
  }

  getSantizeUrl(url: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }

  formatInsertTime(insertTime, dateType = null) {
    if (dateType === 'startEndDate') {
      insertTime = moment(insertTime, 'YYYY-MM-DD HH:mm A');
    } else {
      insertTime = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    }
    if (insertTime.isValid()) {
      return insertTime.format('DD-MM-YYYY hh:mm a');
    }
    return '-';
  }

  formatMoment(insertTime, dateType = null) {
    if (dateType === 'startEndDate') {
      insertTime = moment(insertTime, 'YYYY-MM-DD HH:mm A');
    } else {
      insertTime = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    }
    if (insertTime.isValid()) {
      return insertTime;
    }
    return null;
  }

  showAllColumns(event) {
    this.showAll = event.target.checked;
    setTimeout(() => {
      (this.datatableInstance as any).columns.adjust();
    }, 200);
    this.loadAllProjects();
  }

  // getAllCompleted(event) {
  //   this.showAllCompleted = event.target.checked;
  //   setTimeout(() => {
  //     (this.datatableInstance as any).columns.adjust();
  //   }, 200);
  //   this.pageNumber = 0;
  //   this.loadAllProjects();
  // }

  // getDraftProject(event){
  //   this.showDraftProject = event.target.checked;
  //   setTimeout(() => {
  //     (this.datatableInstance as any).columns.adjust();
  //   }, 200);
  //   this.pageNumber = 0;
  //   this.loadAllProjects();
  // }
  manageRole() {
    switch (parseInt(this.currentUser.user_type, 10)) {
      case 1:
        this.role = 'Superadmin';
        break;
      case 2:
        this.role = 'Client';
        break;
      default:
        this.role = 'Influencer';
        break;
    }
  }

  loadAllProjects(search = '', orderBy= {'column': 'created_at', 'dir': 'desc'}, id = null) {
    let option: any = {includePagination: true,
      ...((this.selectedStatus !== 'all' && this.selectedStatus !== null) ? {project_status: this.selectedStatus} : {}),
      orderBy};
    if (this.showAll || !this.currentUser?.can( 'view-detailed-stats', 'project-ui')) {
      option = {total_influencer_count: true, include_totals: true, includeEmailProcess: true, ...option};
    }
    // if (this.selectedStatus == 'show_completed_projects') {
    //   option = {show_completed_projects: true, ...option};
    // } else if (this.selectedStatus == 'show_draft_project'){
    //   option = {show_draft_project: true, ...option};
    // } else if (this.selectedStatus == 'show_active_project' && this.currentUser?.can('view-templates-menu', 'navigation')) {
    //   option = {show_active_project: true, ...option};
    // }
    this.projectStore.dispatch(ProjectList({
      params: {
        options: JSON.stringify(option),
        page: this.pageNumber + 1,
        ...((this.selectedClient !== 'All' && this.selectedClient !== null) ? {client_id: this.selectedClient} : {}),
        ...((this.selectedOrganization !== 'All' && this.selectedOrganization !== null) ? {organization_id: this.selectedOrganization} : {}),
        ...(id ? {id: id} : {}),
        perPage: this.pageLength,
        search,
      }
    }));
  }

  // loadAllClients(search = '', orderBy= {'column': 'name', 'dir': 'asc'}) {
  //   this.clientStore.dispatch(ClientsListAll({
  //     params: {
  //       options: JSON.stringify({orderBy}),
  //       search,
  //     }
  //   }));
  // }

  getTotalInfluencersCount(influencersCount) {
    let totalCount = 0;
    for (const count in influencersCount) {
      if (influencersCount.hasOwnProperty(count)) {
        totalCount += Number(influencersCount[count]['total']);
      }
    }
    return totalCount;
  }

  projectList(event = null) {
    this.selectedClient = 'All';
    if (event) {
      this.selectedClient = event.value;
    } else {
      this.planners = []
      this.loadAllPlanners();
    }
    this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects();
    }

  onChangeProjectStatus(status) {
    this.selectedStatus = status;
    this.loadAllProjects();
  }
  /**
   * Deleting a project no longer deletes it outright: it is either hidden immediately and
   * permanently deleted once approved, or anonymized in place (stays exactly where it is;
   * only what identifies it is cleared), and either way a Data Protection request goes to
   * the client's account managers for approval. The dialog names them first, so nobody
   * confirms a request without knowing who decides it.
   */
  deleteProject(projectId: number) {
    this.projectService.getDeletionPreview(projectId).subscribe({
      next: (res: any) => {
        const data: DeletionPreview | null = res?.data ?? res ?? null;
        this.confirmDeleteProject(
          projectId, data?.approvers || [], data?.creator_notified || null, null,
          !!data?.is_anonymized,
          // Absent on an older server, where mail was always sent.
          data?.emails_enabled !== false,
          // Absent on an older server, which did not refuse active projects.
          data?.is_active === true,
          data?.activation_ends_at || null,
          data
        );
      },
      error: () => {
        // Still offer the request: it would be created either way, and the dashboard can
        // approve it. If the project is in fact still active the server refuses on submit
        // with the same explanation the dialog would have shown.
        this.confirmDeleteProject(
          projectId, [], null, 'The list of approvers could not be loaded.', false, true,
          false, null
        );
      }
    });
  }

  private confirmDeleteProject(projectId: number, approvers: any[], creator: any | null,
                               warning: string | null, isAnonymized: boolean,
                               emailsEnabled: boolean, isActive: boolean,
                               endsAt: string | null, preview: DeletionPreview | null = null) {
    const project = (this.projects || []).find((item: any) => Number(item.id) === Number(projectId));
    const fullName = (person: any) =>
      [person.first_name, person.last_name].filter(Boolean).join(' ').trim() || person.email;

    // Read by the #deleteProjectTpl body while the dialog is open. `type` starts on
    // 'anonymize': the destructive choice should never be the one someone lands on by
    // clicking through without reading, so a permanent deletion is always a choice made on
    // purpose. The one exception is a project anonymized already, which has nothing left to
    // anonymize - its option is disabled, and deletion is all that remains.
    this.deleteConfirm = {
      approvers: approvers.map((approver: any) => ({name: fullName(approver), email: approver.email})),
      // The creator is told as well, unless they are the one deleting it or already an
      // approver - in which case the server sends nothing and this stays hidden.
      creatorName: creator ? fullName(creator) : null,
      warning,
      isAnonymized,
      emailsEnabled,
      isActive,
      endsAt,
      type: isAnonymized ? 'delete' : 'anonymize',
      scope: canonicalScope(preview ? preview.default_anonymize_scope : null),
      evidenceWarnings: {anonymize: evidenceSizeWarning(preview, 'anonymize'), delete: evidenceSizeWarning(preview, 'delete')}
    };

    // A project that is still running gets an explanation and a single Close: the server
    // refuses both request types until its activity end date has passed, so a Continue
    // button here would only ever lead to that refusal.
    if (isActive) {
      this.sbModal.open({
        title: project ? `"${project.title}" is still active` : 'This project is still active',
        bodyTemplate: this.deleteProjectTpl,
        variant: 'default',
        size: 'md',
        scrollable: false,
        buttons: [{id: 'close', label: 'Close', style: 'secondary', dismiss: true}]
      }).result.catch(() => undefined);
      return;
    }

    this.sbModal.open({
      title: project ? `Delete or anonymize "${project.title}"?` : 'Delete or anonymize this project?',
      bodyTemplate: this.deleteProjectTpl,
      variant: 'confirm',
      size: 'md',
      scrollable: false,
      confirmLabel: 'Continue',
      cancelLabel: 'Keep project'
    }).result.then(() => {
      this.deleteAction = true;
      this.pendingDeleteApprovers = approvers.length;
      const type = this.deleteConfirm.type;
      this.pendingDeleteType = type;
      this.projectStore.dispatch(ProjectDelete({
        projectId,
        requestType: type,
        anonymizeScope: type === 'anonymize' ? canonicalScope(this.deleteConfirm.scope) : undefined
      }));
    }).catch(() => undefined);
  }

  copyProject(projectId: number) {
    this.copyAction = true;
    const modelRef: any = this._modalService.open(ProjectCopyComponent, {centered: true, windowClass: 'sb-entity-form-modal'});
    modelRef.componentInstance.clients = this.planners;
    this.loader$ = null;
    modelRef.result.then((result) => {
      const body = {
        title: result.title,
        client_id: result.client_id,
        options: {
          with_influencers: result.with_influencers
        }
      };
      this.projectStore.dispatch(ProjectCopy({projectId, body}));
    }, (reason) => {
    });
  }

  // getStatus(project) {
  //   const projectEnd = moment(project.end_date, 'YYYY-MM-DD').diff(moment(), 'days');
  //   if (!project.start_date) { return 1; }
  //   if (!project.end_date) { return 1; }
  //   return projectEnd > 0;
  // }
  //
  // getActiveStatus(project) {
  //   const projectStart = project.start_date ? moment().diff(moment(project.start_date, 'YYYY-MM-DD'), 'days') : -1;
  //   return projectStart >= 0 ? 'Active' : 'Draft';
  // }

  getProjectStatus(project) {
    if (!project.activation_starts_at || !project.activation_ends_at) {
      return 'Draft'; // fallback if activation dates are missing
    }

    const now = moment();
    const activationStart = moment(project.activation_starts_at, 'YYYY-MM-DD');
    const activationEnd = moment(project.activation_ends_at, 'YYYY-MM-DD');

    if (now.isBefore(activationStart)) {
      return 'Draft';
    } else if (now.isBetween(activationStart, activationEnd, 'day', '[]')) {
      return 'Active';
    } else {
      return 'Complete';
    }
  }

  changeViewType(type) {
    this.viewType = type;
    this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    this.projectListFilter['projectViewType'] = this.viewType;
    this.cdr.detectChanges();
    this.loadAllProjects(this.projectSearchValue , {'column': 'created_at', 'dir': 'desc'});
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
  }

  projectListByClient(client) {
    // this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // if (this.projectListFilter.hasOwnProperty('selectedClient') && this.projectListFilter['selectedClient'] !== 'All') {
    //   this.selectedClient = 'All';
    //   this.clientPlaceholder = 'Search by Clients';
    // } else {
    //   this.clientPlaceholder = client.name;
    //   this.selectedClient = client.id;
    // }
    if (this.selectedClient) {
      this.clientPlaceholder = client.name;
      this.selectedClient = client.id;
    } else {
      this.selectedClient = 'All';
      this.clientPlaceholder = 'Search by Clients';
    }
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    // this.projectListFilter['selectedClientName'] = this.clientPlaceholder;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects();
  }

  getReferralsRatePercentage(project) {
    if (project && project.referrals_count) {
      if (project.pageviews_count > 0) {
        return ((project.referrals_count / project.pageviews_count) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  getOpenClickRate(project) {
    if (project && project.emailProgress) {
      if (project.emailProgress.clicked > 0) {
        return ((project.emailProgress.clicked / project.emailProgress.sent) * 100).toFixed(2);
      }
      return 0;
    } else {
      return 0;
    }
  }

  async onSearchProjectList() {
    this.selectedClient = 'All';
    this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects(this.projectSearchValue, {'column': 'created_at', 'dir': 'desc'});
  }

  // async onSearchClientList(event) {
  //   const search = event.target.value;
  //   this.loadAllClients(search, {'column': 'name', 'dir': 'asc'});
  // }

  onClientSelect(client) {
    this.selectedClient = client.id;
    this.clientPlaceholder = client.name;
    this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    // this.projectListFilter['selectedClientName'] = this.clientPlaceholder;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects();
    this.planners = [];
  }

  onClearClientFilter() {
    this.cdr.detectChanges();
    this.selectedClient = 'All';
    this.clientPlaceholder = 'Search by Clients';
    // this.projectListFilter = JSON.parse(localStorage.getItem('projectFilterList')) ? JSON.parse(localStorage.getItem('projectFilterList')) : {};
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    // // this.projectListFilter['selectedClientName'] = this.clientPlaceholder;
    // localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects();
    this.planners = [];
  }

  onProjectSelect(project) {
    this.cdr.detectChanges();
    // this.selectedStatus = 'All';
    // this.statusPlaceholder = 'All';
    // this.projectListFilter['selectedProjectStatus'] = this.selectedStatus;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.selectedClient = 'All';
    // this.projectListFilter['selectedClient'] = this.selectedClient;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.projectSearchValue = '';
    this.projectPlaceholder = project === 'all' ? 'All Projects' : project.title;
    this.projectListFilter['projectViewType'] = this.viewType;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
    this.loadAllProjects('', {'column': 'created_at', 'dir': 'desc'},  project.id);
    this.projectListFilter['selectedProjectId'] = project.id;
    localStorage.setItem('projectFilterList', JSON.stringify(this.projectListFilter));
  }

  handleSearchValue(searchTerm) {
    this.loader$ = null;
    this.clientSearchValue = searchTerm.term;
    this.planners = [];
    this.loadAllPlanners(searchTerm.term);
  }

  handleScroll() {
    this.loader$ = null;
    if (this.planners.length < this.totalClients) {
      this.loadAllPlanners(this.clientSearchValue, this.clientPageNumber);
    }
  }

  loadAllOrganizations() {
    this.organizationStore.dispatch(OrganizationsListAll({}));
  }

  onOrganizationSelected(event = null) {
    this.selectedOrganization = 'All';
    if (event) {
      this.selectedOrganization = event.value;
    }
    this.loadAllProjects();
  }

  loadAllPlanners(search = '', page = 0, perPage = 10, orderBy= {'column': 'name', 'dir': 'asc'}, fields = ['id', 'name']) {
    this.clientPageNumber = page + 1;
    this.clientStore.dispatch(ClientsList({
      params: {
        options: JSON.stringify({includePackage: true, includePagination: true, orderBy, fields}),
        page: this.clientPageNumber,
        perPage,
        search
      }
    }));
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }

}
